<template>

  <div></div>

</template>

<script>

import L from 'leaflet'
import { findRealParent } from 'vue2-leaflet'
import 'leaflet.gridlayer.googlemutant'

export default {
  name: 'google-maps-layer',

  props: [ 'styles' ],

  data () {
    return {
      apikey: this.$store.state.gmap.apikey,
      config: {
        roadmap: { name: this.$t('map.controls.google.roadmap'), style: 'roadmap' },
        satellite: { name: this.$t('map.controls.google.satellite'), style: 'satellite' },
        terrain: { name: this.$t('map.controls.google.terrain'), style: 'terrain' },
        hybrid: { name: this.$t('map.controls.google.hybrid'), style: 'hybrid' },
      },
      objects: {
        map: null,
        layers: null,
        mutants: []
      }
    }
  },

  methods: {
    insertScript () {
      if (!(typeof google === 'object' && typeof google.maps === 'object')) {
        [
          'https://maps.googleapis.com/maps/api/js?key=' + this.apikey,
        ].forEach(script => {
          const element = document.createElement('script')
          element.setAttribute('src', script)
          document.head.appendChild(element)
        });
      }
    }
  },

  mounted() {
    this.objects.mutants = []
    this.insertScript()

    const map = findRealParent(this.$parent).mapObject

    const layers = ([]).concat(this.styles)
        .map(style => this.config[style])
        .map(style => L.gridLayer.googleMutant({
          type: style.style,
          maxZoom: 24
        }))

    const controls = Object.fromEntries(
      layers.map(layer => [ this.config[layer.options.type].name, layer ])
    )

    this.objects.controls = L.control.layers(controls).addTo(map)
    layers[0].addTo(map)

    this.objects.layers = layers
    this.objects.map = map
  },

  beforeDestroy() {
    this.objects.controls.remove()
    this.objects.layers.forEach(layer => layer.remove())
  },

  components: {

  }
}

</script>

<style lang="scss" scoped>

</style>
